export const INLINE_SVG_MAX_BYTES = 256 * 1024;
export const INLINE_SVG_PREFIX = "data:image/svg+xml;base64,";
export function encodeInlineSvg(markup: string): string {
  const bytes = new TextEncoder().encode(markup);
  if (bytes.length > INLINE_SVG_MAX_BYTES) throw new Error("Inline SVG exceeds 256 KiB");
  let binary = "";
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return INLINE_SVG_PREFIX + btoa(binary);
}
// Structural validation only. Inline DOM consumers must sanitize untrusted SVG before insertion.
export function decodeInlineSvg(value: string): string {
  if (!value.startsWith(INLINE_SVG_PREFIX)) throw new Error("Expected base64 SVG asset");
  const payload = value.slice(INLINE_SVG_PREFIX.length);
  if (payload.length > Math.ceil(INLINE_SVG_MAX_BYTES / 3) * 4 || (payload.length % 4 !== 0 || !/^[A-Za-z0-9+/]*={0,2}$/.test(payload))) {
    throw new Error("Invalid or oversized inline SVG (max 256 KiB)");
  }
  const binary = atob(payload);
  if (binary.length > INLINE_SVG_MAX_BYTES) throw new Error("Inline SVG exceeds 256 KiB");
  const markup = new TextDecoder("utf-8", {fatal: true}).decode(Uint8Array.from(binary, (c) => c.charCodeAt(0)));
  if (!/^\s*<svg[\s>]/i.test(markup)) throw new Error("Inline asset must have an SVG root");
  return markup;
}
